import { render, staticRenderFns } from "./BankDetailsModal.vue?vue&type=template&id=d255e53c&scoped=true&"
import script from "./BankDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./BankDetailsModal.vue?vue&type=script&lang=ts&"
import style0 from "./BankDetailsModal.vue?vue&type=style&index=0&id=d255e53c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d255e53c",
  null
  
)

export default component.exports